/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandComedyCentral = createReactComponent("outline", "brand-comedy-central", "IconBrandComedyCentral", [["path", { "d": "M5.343 17.657a8 8 0 1 0 0 -11.314", "key": "svg-0" }], ["path", { "d": "M13.828 9.172a4 4 0 1 0 0 5.656", "key": "svg-1" }]]);

export { IconBrandComedyCentral as default };
//# sourceMappingURL=IconBrandComedyCentral.mjs.map
